module.exports = __webpack_public_path__ + "static/media/impossible-staircase_cover.c708cea2.jpg";